import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class ExpandSearch extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        isIE78: PropTypes.bool,
        defaultIsExpand: PropTypes.bool,
    };

    static defaultProps = {
        defaultIsExpand: false,
    };

    state = {
        data: this.props.content,
        searchTxt: this.props.content[0].keyword,
        current: 0,
        isShow: false,
        isExpand: this.props.defaultIsExpand,
    };

    handleExpand = () => {
        const { isExpand } = this.state;

        this.setState({
            isExpand: !isExpand,
        });
    };

    handleOptionShow = () => {
        const { isShow } = this.state;

        this.setState({
            isShow: !isShow,
        });
    };

    handleSelect = e => {
        const { data, isShow } = this.state;
        const selectVal = Number(e.currentTarget.attributes['value'].value);

        this.setState({
            current: selectVal,
            searchTxt: data[selectVal].keyword,
            isShow: !isShow,
        });
    };

    handleChange = e => {
        const val = e.currentTarget.value;

        this.setState({ searchTxt: val });
    };

    handleKeydown = e => {
        if (e.key === 'Enter') {
            this.handleClick();
        }
    };

    handleClick = () => {
        const { data, current, searchTxt } = this.state;
        const type = data[current].type;

        if (type === 'sofeng') {
            window.open(`//so.ifeng.com/?q=${encodeURI(searchTxt)}&c=1`);
        } else if (type === 'hq') {
            window.open(`//app.finance.ifeng.com/hq/search.php?keyword=${encodeURI(searchTxt)}`);
        } else if (type === 'car') {
            window.open(`//data.auto.ifeng.com/search/search.do?keywords=${encodeURI(searchTxt)}`);
        } else if (type === 'video') {
            window.open(`//so.ifeng.com/?q=${encodeURI(searchTxt)}&c=5`);
        }
    };

    handleFocus = e => {
        const { data, current } = this.state;
        const val = e.currentTarget.value;

        if (data[current].keyword === val) {
            this.setState({ searchTxt: '' });
        }
    };

    handleBlur = e => {
        const { data, current } = this.state;
        const val = e.currentTarget.value;

        if (val === '') {
            this.setState({ searchTxt: data[current].keyword });
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { data, current, searchTxt, isShow, isExpand } = this.state;
        const { isIE78,defaultIsExpand } = this.props;

        return (
            <div className={styles.search_box}>
                {isExpand ? (
                    <div className={styles.search}>
                        <input
                            type="text"
                            value={searchTxt}
                            className={styles.text}
                            onChange={this.handleChange}
                            onKeyDown={this.handleKeydown}
                            onFocus={this.handleFocus}
                            onBlur={this.handleBlur}
                        />
                        <div className={styles.select}>
                            <span
                                className={isIE78 ? styles.checked : styles.checked_2x}
                                onClick={this.handleOptionShow}>
                                <span>{data[current].name}</span>
                                <em />
                            </span>
                            {isShow ? (
                                <ul>
                                    {data.map((item, index) => (
                                        <li key={index}>
                                            <a href="javascript:void(0);" value={index} onClick={this.handleSelect}>
                                                {item.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                ''
                            )}
                        </div>
                        <div className={styles.btn} onClick={this.handleClick}>
                            搜索
                        </div>
                        {!defaultIsExpand && <div className={isIE78 ? styles.close : styles.close_2x} onClick={this.handleExpand} />}
                    </div>
                ) : (
                    <div className={isIE78 ? styles.search_btn : styles.search_btn_2x} onClick={this.handleExpand}>
                        <span />
                        <span>搜索</span>
                    </div>
                )}
            </div>
        );
    }
}

export default ExpandSearch;
